import ReactDOM from 'react-dom'
import { useState, useEffect } from 'react'
import ReactLoading from 'react-loader-spinner'
import { useAppSelector } from 'redux/hooks'
import Modal from 'components/Modal/Modal'
import { Button, Form } from 'react-bootstrap'
import { Status } from 'redux/features/favoris/slice'
import ToastAlert from 'components/ToastAlert'
import {
  makeSelectFavoriStatusUrlAnnonce,
  makeSelectFavoriErrorUrlAnnonce,
} from 'redux/features/favoris/selectors'
import s from '../Modal.module.scss'

interface Props {
  uid: string
  urlAnnonce: string
  show: boolean
  onHide: () => void
  onPass: () => void
  onSubmit: (urlAnnonce: string) => void
}

const ModalUrlAnnonce = ({
  uid,
  show,
  onSubmit,
  onHide,
  onPass,
  urlAnnonce: defaultUrlAnnonce,
}: Props): JSX.Element => {
  const statusUrlAnnonce = useAppSelector(makeSelectFavoriStatusUrlAnnonce(uid))
  const errorUrlAnnonce = useAppSelector(makeSelectFavoriErrorUrlAnnonce(uid))
  const [urlAnnonce, setUrlAnnonce] = useState(defaultUrlAnnonce || '')
  const node = document.querySelector('.modal')

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    onSubmit(urlAnnonce)
  }
  useEffect(() => {
    if (!defaultUrlAnnonce) setUrlAnnonce('')
  }, [defaultUrlAnnonce])

  return (
    <>
      {node &&
        ReactDOM.createPortal(
          <ToastAlert
            show={statusUrlAnnonce === Status.Failed}
            variant="danger"
          >
            {errorUrlAnnonce}
          </ToastAlert>,
          node
        )}
      <Modal
        additionalModalClassNames={s.modal}
        show={show}
        title="Associer une annonce"
        body={
          <Form onSubmit={handleSubmit}>
            <h2 className={s.title}>
              Souhaitez-vous relier l&apos;adresse url d&apos;une annonce pour
              l&apos;associer à cette parcelle favorite ?
            </h2>
            <p className={s.text}>
              &quot;Associer une annonce&quot; vous permet de relier les
              résultats que vous enregistrez dans vos favoris à une annonce
              diffusée sur un portail. Une aide qui vous permet ensuite
              d&apos;organiser et distinguer toutes les parcelles enregistrées
              en favori.
            </p>
            <Form.Group controlId="urlAnnonce">
              <Form.Label className={s.label}>
                Copiez ici l&apos;adresse url de l&apos;annonce
              </Form.Label>
              <Form.Control
                className={s.input}
                type="text"
                value={urlAnnonce}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setUrlAnnonce(e.target.value)
                }
              />
              {/* {statusUrlAnnonce === ActionType.FAILED_URL_ANNONCE && (
                <Form.Text className={s.error}>{errorUrlAnnonce}</Form.Text>
              )} */}
            </Form.Group>
            <div className={s.controls}>
              <Button variant="outline-primary" onClick={onPass}>
                Passer
              </Button>
              <Button variant="primary" type="submit">
                {statusUrlAnnonce === Status.Pending ? (
                  <ReactLoading type="Oval" color="#fff" height="2.4rem" />
                ) : (
                  'Enregister'
                )}
              </Button>
            </div>
          </Form>
        }
        onCloseButtonClick={onHide}
      />
    </>
  )
}

export default ModalUrlAnnonce
